import { render, staticRenderFns } from "./TravelPlans.vue?vue&type=template&id=0565cfca&"
import script from "./TravelPlans.vue?vue&type=script&lang=js&"
export * from "./TravelPlans.vue?vue&type=script&lang=js&"
import style0 from "./TravelPlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelPlans.vue"
export default component.exports